<template>
  <Modal v-if="showModalAddComment" @close="closeModalAndFormData">
    <div class="addComment">
      <div class="addComment__header">
        <span class="title">
          {{ $t('addCommentSensor') }}
        </span>
        <img
          class="addComment__header-img"
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="closeModalAndFormData"
        />
      </div>
      <FormKit
        id="addComment-form"
        v-model="formData"
        type="form"
        :actions="false"
        @submit="submitHandler"
      >
        <label class="label-comment" for="comment">
          {{ $t('comment') }}
        </label>
        <textarea
          id="comment"
          v-model="formData.comment"
          class="input-comment"
          maxlength="250"
        >
        </textarea>
      </FormKit>
      <div class="addComment__buttons">
        <Button variant="filled" :title="$t('save')" @click="addComment" />
        <Button
          variant="bordered"
          :title="$t('cancel')"
          @click="closeModalAndFormData"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { SendTemperatureComment } from '@/store/modules/pharmacy/types';
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

@Options({
  name: 'AddComment',
  props: ['showModalAddComment', 'editSensorData', 'pharmacyId'],
  data() {
    return {
      formData: { comment: '' }
    };
  },
  methods: {
    ...mapActions('pharmacy', ['sendCommentTemperatures']),
    async submitHandler(data: SendTemperatureComment) {
      this.loading = true;

      await this.sendCommentTemperatures({
        data: data,
        pharmacyId: this.pharmacyId,
        sensorId: this.editSensorData.id
      });

      this.loading = false;

      this.closeModalAndFormData();
    },
    closeModalAndFormData() {
      this.formData = {
        comment: ''
      };

      this.$emit('closeModal');
    },
    addComment() {
      this.$formkit.submit('addComment-form');
    }
  }
})
export default class AddComment extends Vue {}
</script>

<style lang="scss" scoped>
.addComment {
  max-width: 400px;
  width: 100%;
  height: 100%;
  padding: 24px;
  .addComment__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    .createNewSensor__header-img {
      cursor: pointer;
    }
  }
  #addComment-form {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 24px;
    width: 400px;
    height: 177px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 366px;
      height: 140px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .addComment__buttons {
    :first-child {
      margin-right: 12px;
    }
  }
}
</style>
